const log: any = {};

/**
 * @description 返回这个样式的颜色值
 * @param {String} type 样式名称 [ primary | success | warning | danger | text ]
 */
function typeColor(type = 'default') {
	let color = '';
	switch (type) {
		case 'default':
			color = '#35495E';
			break;
		case 'primary':
			color = '#3488FF';
			break;
		case 'success':
			color = '#43B883';
			break;
		case 'warning':
			color = '#E6A23C';
			break;
		case 'danger':
			color = '#F56C6C';
			break;
		default:
			break;
	}
	return color;
}

/**
 * @description 打印一个 [ title | text ] 样式的信息
 * @param {String} title title text
 * @param {String} info info text
 * @param {String} type style
 */
log.capsule = (title: string, info: string, type = 'primary') => {
	// eslint-disable-next-line no-console
	console.log(
		`%c ${title} %c ${info} %c`,
		'background:#35495E; padding: 1px; border-radius: 3px 0 0 3px; color: #FFF;',
		`background:${typeColor(type)}; padding: 1px; border-radius: 0 3px 3px 0;  color: #FFF;`,
		'background:transparent'
	);
};

/**
 * @description 打印彩色文字
 */
log.colorful = (textArr: any[]) => {
	// eslint-disable-next-line no-console
	console.log(
		`%c${textArr.map((t) => t.text || '').join('%c')}`,
		...textArr.map((t) => `color: ${typeColor(t.type)};`)
	);
};

/**
 * @description 打印 default 样式的文字
 */
log.default = (text: string) => {
	log.colorful([{ text }]);
};

/**
 * @description 打印 primary 样式的文字
 */
log.primary = (text: string) => {
	log.colorful([{ text, type: 'primary' }]);
};

/**
 * @description 打印 success 样式的文字
 */
log.success = (text: string) => {
	log.colorful([{ text, type: 'success' }]);
};

/**
 * @description 打印 warning 样式的文字
 */
log.warning = (text: string) => {
	log.colorful([{ text, type: 'warning' }]);
};

/**
 * @description 打印 danger 样式的文字
 */
log.danger = (text: string) => {
	log.colorful([{ text, type: 'danger' }]);
};

export default log;
